// Indonesian
export const id = {
  'app.name':           'Kardolive',
  'app.tagline':        'Portal pelanggan',
  'app.signOut':        'Keluar',

  'login.email':        'Email',
  'login.password':     'Kata sandi',
  'login.signIn':       'Masuk',
  'login.signingIn':    'Sedang masuk…',
  'login.failed':       'Gagal masuk',
  'login.newAccount':   'Baru di Kardolive?',
  'login.createAccount':'Buat akun gratis →',

  'nav.workspace':      'Ruang kerja',
  'nav.templates':      'Templat',
  'nav.live':           'Siaran langsung',
  'nav.rooms':          'Ruang & obrolan',
  'nav.content':        'Konten',
  'nav.developer':      'Pengembang',
  'nav.account':        'Akun',

  'nav.overview':       'Ringkasan',
  'nav.projects':       'Proyek',
  'nav.chat':           'Konsol obrolan',
  'nav.sessions':       'Sesi',
  'nav.streams':        'Siaran langsung',
  'nav.studio':         'Studio',
  'nav.recordings':     'Rekaman',
  'nav.apiKeys':        'Kunci API',
  'nav.webhooks':       'Webhooks',
  'nav.webhookTester':  'Penguji Webhook',
  'nav.networkTest':    'Tes jaringan',
  'nav.embed':          'Widget tersemat',
  'nav.sdk':            'SDK & dokumentasi',
  'nav.docs':           'Dokumen Developer',
  'nav.analytics':      'Analitik',
  'nav.settings':       'Pengaturan',

  'overview.welcome':       'Selamat datang kembali, {name}',
  'overview.plan':          '{tenant} · paket {plan}',
  'overview.newStream':     'Siaran baru',
  'overview.kpi.live':           'Sedang langsung',
  'overview.kpi.live.broadcasting': 'siaran berlangsung',
  'overview.kpi.live.nothing':    'tidak ada siaran',
  'overview.kpi.total':           'Total siaran',
  'overview.kpi.total.sub':       'sepanjang waktu',
  'overview.kpi.sessions':        'Sesi · 30 hari',
  'overview.kpi.sessions.sub':    'peristiwa publikasi',
  'overview.kpi.recordings':      'Rekaman',
  'overview.kpi.recordings.sub':  'siap diputar',
  'overview.recentStreams':       'Siaran terbaru',
  'overview.recentSessions':      'Sesi terbaru',
  'overview.viewAll':             'Lihat semua →',
  'overview.empty.title':         'Belum ada siaran',
  'overview.empty.body':          'Buat siaran pertama Anda untuk mulai menyiarkan.',
  'overview.empty.action':        'Buat siaran',
  'overview.noSessions':          'Belum ada sesi',

  'status.live':        'LANGSUNG',
  'status.idle':        'TIDAK AKTIF',
  'status.ended':       'BERAKHIR',
  'status.archived':    'DIARSIPKAN',

  'common.save':        'Simpan',
  'common.cancel':      'Batal',
  'common.delete':      'Hapus',
  'common.edit':        'Edit',
  'common.create':      'Buat',
  'common.confirm':     'Konfirmasi',
  'common.loading':     'Memuat…',
  'common.error':       'Kesalahan',
  'common.retry':       'Coba lagi',

  // Dashboard navigation and account controls.
  "nav.skipContent": "Langsung ke konten halaman",
  "nav.streamTemplates": "Templat siaran",
  "nav.boards": "Papan interaktif",
  "nav.menu": "Buka navigasi",
  "nav.closeMenu": "Tutup navigasi",
  "nav.scenarios": "Skenario",
  "nav.premieres": "Penayangan perdana",
  "nav.clips": "Klip",
  "dashboard.account": "Akun",
  "dashboard.language": "Bahasa",
  "dashboard.appearance": "Tampilan",
  "nav.allStreams": "Semua siaran",
  "nav.destinations": "Tujuan",
  "nav.ecommerce": "Perdagangan elektronik",
  "nav.products": "Produk",
  "nav.services": "Layanan",
  "nav.collections": "Koleksi",
  "nav.orders": "Pesanan",
  "nav.commerceSettings": "Pengaturan perdagangan",
  "nav.engagement": "Interaksi",
  "theme.light": "Beralih ke mode terang",
  "theme.dark": "Beralih ke mode gelap",
  "role.owner": "Pemilik",
  "role.admin": "Administrator",
  "role.member": "Anggota",
  "role.viewer": "Pengamat",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "Aktif",
  "streams.archived": "Diarsipkan",
  "streams.monitor": "Monitor sumber",
  "streams.create": "Buat siaran langsung",
  "streams.list": "Daftar",
  "streams.grid": "Kisi",
  "streams.view": "Tampilan siaran",
  "streams.searchLabel": "Cari acara",
  "streams.searchHint": "Cari nama acara",
  "streams.solutionFilter": "Filter acara menurut jenis",
  "streams.statusFilter": "Filter acara menurut status",
  "streams.dateFilter": "Filter menurut tanggal dibuat",
  "streams.allSolutions": "Semua jenis",
  "streams.custom": "Pengaturan lama atau khusus",
  "streams.allStatuses": "Semua status",
  "streams.anyTime": "Semua tanggal pembuatan",
  "streams.last7": "Dibuat dalam 7 hari terakhir",
  "streams.last30": "Dibuat dalam 30 hari terakhir",
  "streams.count": "Menampilkan {shown} dari {total} acara",
  "streams.noMatch": "Tidak ada acara yang sesuai dengan filter.",
  "streams.clearFilters": "Hapus filter",
  "streams.refreshFailed": "Daftar siaran tidak dapat diperbarui",
  "streams.loadFailed": "Siaran tidak dapat dimuat",
  "streams.stale": "Daftar terakhir ditampilkan. Status mungkin telah berubah.",
  "streams.connectionHint": "Periksa koneksi dan muat ulang daftar.",
  "streams.retrying": "Mencoba lagi…",
  "streams.retry": "Coba lagi",
  "streams.restoreFailed": "Siaran tidak dapat dipulihkan",
  "streams.restoreHint": "Periksa koneksi dan perbarui daftar untuk memastikan status terbaru sebelum mencoba lagi.",
  "streams.unused": "Siaran belum digunakan: {count}",
  "streams.unusedHint": "Belum ada siaran atau tayangan ulang. Arsipkan untuk merapikan daftar; tidak ada yang dihapus.",
  "streams.reviewArchive": "Tinjau dan arsipkan",
  "streams.loading": "Memuat siaran…",
  "streams.archiveEmpty": "Belum ada arsip. Siaran yang diarsipkan beserta tayangan ulangnya tetap di sini sampai dipulihkan.",
  "streams.restore": "Pulihkan",
  "streams.firstTitle": "Buat siaran pertama Anda",
  "streams.firstBody": "Pilih pengaturan untuk penjualan, kelas, atau layanan, atau mulai dengan siaran kosong. Siarkan lewat browser, ponsel, atau OBS.",
  "streams.blank": "Siaran kosong",
  "streams.broadcasts": "Siaran: {count}",
  "streams.replays": "Tayangan ulang: {count}",
  "streams.sessions": "Sesi: {count}",
  "streams.recordings": "Rekaman: {count}",
  "streams.mode.BROADCAST": "Siaran",
  "streams.mode.LOW_LATENCY": "Latensi rendah",
  "streams.mode.REALTIME": "Waktu nyata",
  "streams.key": "Kunci",
  "streams.archiveTitle": "Arsipkan siaran yang belum digunakan",
  "streams.archiveHint": "Siaran ini belum pernah ditayangkan. Pulihkan kapan saja melalui tab Diarsipkan.",
  "streams.archiveFailed": "{count} siaran tidak dapat diarsipkan; mungkin sudah mulai mengudara. Siaran lainnya telah diarsipkan.",
  "streams.archiving": "Mengarsipkan…",
  "streams.archiveCount": "Arsipkan {count}",
  "streamType.webinar": "Webinar bisnis dan peluncuran",
  "streamType.classroom": "Kelas dan les",
  "streamType.training": "Pelatihan perusahaan",
  "streamType.conference": "Konferensi dan pameran",
  "streamType.shopping": "Belanja langsung",
  "streamType.auction": "Lelang langsung",
  "streamType.consultation": "Konsultasi pribadi",
  "streamType.creator": "Siaran kreator dan komunitas",
  "streamType.audio": "Ruang audio dan podcast",
  "streamType.sports": "Olahraga dan esport",
  "streamType.performance": "Konser dan pertunjukan",
  "streamType.community": "Ibadah dan penggalangan dana",
  "streamType.tour": "Tur dan demonstrasi",
  "streamType.fitness": "Kebugaran dan lokakarya",
  "streamType.public-meeting": "Berita dan rapat publik",
  "streamType.continuous": "Kanal berkelanjutan dan kamera",
  "streams.close": "Tutup",
};
